import { AllocationDocumentFinanceType } from "@/enums/enums";

export class AllocationItemModel {
  allocationDocumentFinanceType!: AllocationDocumentFinanceType;
  description!: string;
  id!: number;
  isArchived!: boolean;
  isDeleted!: boolean;
  name!: string;
  number!: string;
}
